import { GlModal } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
export default {
    name: 'ForkSuggestionModal',
    components: {
        GlModal
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        forkPath: {
            type: String,
            required: true
        }
    },
    computed: {
        primaryAction () {
            return {
                text: __('Fork'),
                attributes: {
                    variant: 'confirm',
                    href: this.forkPath,
                    class: 'gl-w-full sm:gl-w-auto',
                    'data-method': 'post',
                    'data-testid': 'fork'
                }
            };
        },
        secondaryAction () {
            return {
                text: __('Cancel'),
                attributes: {
                    class: 'gl-w-full sm:gl-w-auto',
                    'data-testid': 'cancel'
                }
            };
        }
    }
};
